import React from 'react'
import { graphql, useStaticQuery } from "gatsby"

const ApplySticky = () => {

    const { wpMenu } = useStaticQuery(graphql`
        {
            wpMenu(slug: {eq: "footer-menu"}) {
                footer {
                    fieldGroupName
                    applyNow
                }
            }
        }
    `)

    if (wpMenu?.footer?.applyNow) {
        return (
            <div className="apply-sticky">
                <a href={wpMenu?.footer?.applyNow} className="btn button-solid">Apply</a>
            </div>
        )
    }
    return null;
}

export default ApplySticky
